module.exports = __webpack_public_path__ + "img/romana-al-taglio.f8464fe9.jpg";